import { ICore } from "../apiClient/interfaces";
import { getCoreApiNetworkClient } from "../apiClient/networkClient";
import { useQuery } from "@tanstack/react-query";

export function useStudentLimits(
  token?: string,
  apiRole?: string,
): {
  studentLimits: ICore.IStudentV4Limits | null;
  studentLimitsLoading: boolean;
  studentLimitsError: any;
  refreshStudentLimits: () => void;
} {
  const apiClient = getCoreApiNetworkClient({
    token: token,
  });
  const shouldFetch = !!token && apiRole == "student";
  const fetcher = (url: string) => apiClient.get(url).then((res) => res.data);

  const { data, error, isLoading, isRefetching, refetch } = useQuery({
    queryKey: ["student limits", apiRole, token],
    queryFn: () => fetcher("/v4/students/limits/"),
    enabled: shouldFetch,
  });

  return {
    studentLimits: shouldFetch ? data : null,
    studentLimitsLoading: isLoading,
    studentLimitsError: error,
    refreshStudentLimits: refetch,
  };
}
